module.exports = __webpack_public_path__ + "static/home1-special-product-tabs-bc3e66d68bf3c79e568e7fc06719d635.jpg";